import { render, staticRenderFns } from "./PredictCard.vue?vue&type=template&id=5d245bf8&scoped=true&"
import script from "./PredictCard.vue?vue&type=script&lang=js&"
export * from "./PredictCard.vue?vue&type=script&lang=js&"
import style0 from "./PredictCard.vue?vue&type=style&index=0&id=5d245bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d245bf8",
  null
  
)

export default component.exports